import inquirer from 'inquirer'

export default new inquirer.ui.BottomBar()
